import React from 'react';
import { DollarSignIcon } from 'lucide-react';
import { motion } from 'framer-motion';
const tiers = [{
  label: 'Starting',
  amount: '$4K–$6K',
  period: 'per month'
}, {
  label: 'Consistent Performer',
  amount: '$8K–$12K',
  period: 'per month'
}, {
  label: 'Top Rookie',
  amount: '$50K+',
  period: 'first 90 days'
}];
export function Compensation() {
  return <section className="py-20 bg-white" data-id="element-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-13">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-14">
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-charcoal mb-4" data-id="element-15">
            Starting reps earn $4K–$6K/month.
          </h2>
          <p className="text-2xl text-maroon font-bold" data-id="element-16">
            Top rookies cleared $50K+ in 90 days.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-charcoal rounded-xl p-8 sm:p-12 mb-12 max-w-4xl mx-auto" data-id="element-17">
          <div className="flex flex-col md:flex-row items-center gap-8" data-id="element-18">
            <div className="flex-shrink-0" data-id="element-19">
              <div className="w-24 h-24 rounded-full bg-maroon flex items-center justify-center text-white font-bold text-3xl" data-id="element-20">
                J
              </div>
            </div>
            <div className="flex-1 text-center md:text-left" data-id="element-21">
              <div className="text-maroon font-bold text-sm uppercase tracking-wider mb-2" data-id="element-22">
                Featured Success Story
              </div>
              <blockquote className="text-xl sm:text-2xl text-white font-semibold mb-4 leading-relaxed" data-id="element-23">
                "Johnny came in from the Marines. No sales experience. $52K in
                his first 3 months. He hasn't slowed down since."
              </blockquote>
              <div className="text-gray-400" data-id="element-24">
                <span className="font-semibold text-white" data-id="element-25">Johnny</span> —
                Former Marine, Field Rep
              </div>
            </div>
          </div>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-26">
          {tiers.map((tier, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.4 + index * 0.1
        }} className="bg-off-white border-2 border-gray-200 rounded-lg p-8 text-center hover:border-maroon transition-colors" data-id="element-27">
              <div className="w-12 h-12 bg-maroon/10 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-28">
                <DollarSignIcon className="w-6 h-6 text-maroon" data-id="element-29" />
              </div>
              <div className="text-sm font-bold text-gray-600 uppercase tracking-wider mb-2" data-id="element-30">
                {tier.label}
              </div>
              <div className="font-display text-4xl text-charcoal mb-1" data-id="element-31">
                {tier.amount}
              </div>
              <div className="text-sm text-gray-600" data-id="element-32">{tier.period}</div>
            </motion.div>)}
        </div>

        <p className="mt-10 text-xs text-gray-500 leading-relaxed max-w-3xl mx-auto text-center" data-id="element-33">
          <strong className="text-gray-600" data-id="element-34">Income Disclaimer:</strong> The
          earnings figures referenced above, including Johnny's results, reflect
          the actual past performance of individual representatives and are
          provided for illustrative purposes only. They are not a guarantee,
          promise, or projection of your future earnings. Field representative
          compensation is commission-based with no guaranteed minimum income.
          Actual results vary significantly based on individual effort, skill,
          work ethic, schedule, experience, market conditions, and other
          factors. Your results may be substantially more or less than the
          examples shown.
        </p>
      </div>
    </section>;
}